import React, { useState } from 'react';
import clsx from 'clsx';
import { GalleryImage } from './GalleryImage';
import { GalleryThumbnail } from './GalleryThumbnail';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { Modal } from '@/stories/organisms/Modal/Modal';

import styles from './gallery-dialog.module.css';

export interface GalleryDialogProps {
  images: string[],
  open: boolean,
  selected: number,
  onClose: () => void
  setSelectedIndex: (index: number) => void
}

export const GalleryDialog = ({ images, selected, setSelectedIndex, open, onClose}: GalleryDialogProps)=> {
  const [active, setActive] = useState(false)
  const goNext = () => {
    if (!active) setActive(true)
    if (selected < (images.length - 1 )) {
      setSelectedIndex(selected + 1)
    }
  }
  const goPrev = () => {
    if (!active) setActive(true)
    if (selected > 0) setSelectedIndex(selected - 1)
  }

  const goTo = (id: number) => {
    if (!active) setActive(true)
    setSelectedIndex(id)
  }

  return open ? (
    <Modal onClose={onClose} open>
      <div className={styles.top}>
        {images.length > 0 ? (
          <>
            {selected === 0 ? null : <button type='button' className={clsx(styles.btn, styles.prev)} onClick={goPrev}><span className='sr-only'>Image précédente</span><Icon icon='angle-left' size={'4x'}/></button>}
            {selected === images.length -1 ? null : <button type='button' className={clsx(styles.btn, styles.next)} onClick={goNext}><span className='sr-only'>Image suivant</span><Icon icon='angle-right' size={'4x'}/></button>}
          </>
        ) : null }
        <div className={styles.full}>
          {images.map((image, i) => <GalleryImage key={i} image={image} isSelected={i == selected && active} alt=''/> )}
        </div>
      </div>
      <div className={styles.thumbnails}>
        {images.map((image, i) => <GalleryThumbnail key={i} image={image} alt='' isSelected={i == selected && active} onClick={() => goTo(i)}/> )}
      </div>
    </Modal>
  ) : null
};
